module.exports = __webpack_public_path__ + "d78c1e45.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/fb_icon.png
// module id = 1669
// module chunks = 15 17 18 19 31 32 36